/* ============================================================================
 * ETIQUETAS DE GEOMETRÍA (figuras) EN TARJETAS + ARREGLO DE "AGOTADO" — Motion
 * ----------------------------------------------------------------------------
 * Adaptado del que se hizo en Cohynsa, pero para la estructura de MotionFluid
 * (tema Ignite): tarjetas .card-wrapper/.card__information y selector de
 * variantes por PÍLDORAS de radio (no <select>). Auto-contenido: inyecta su
 * propio CSS y no toca el markup del tema.
 *
 * 1) EN LAS TARJETAS (colección / grid / búsqueda): a las CONEXIONES con opción
 *    "Geometría (Figura)" les agrega una fila de mini-fotos circulares de cada
 *    figura (Recta, Codo 45°, Codo 90°, …). Objetivo: que el cliente vea de un
 *    vistazo que ese producto viene en varias geometrías y no crea que solo
 *    existe la de la foto principal. Al pasar el cursor / tocar un círculo cambia
 *    SOLO la imagen de la tarjeta; al tocar, además "Ver opciones" abre el
 *    producto con esa figura ya seleccionada (?variant=).
 *
 * 2) EN LA PÁGINA DE PRODUCTO: arregla el "Agotado" falso. En estos productos no
 *    toda medida existe en toda figura (matriz incompleta) y el tema DESHABILITA
 *    el botón de compra al caer en una combinación inexistente. Aquí, al elegir
 *    una figura no combinable con la medida, se AJUSTA la medida a una compatible
 *    → siempre cae en una variante válida y el botón queda activo.
 *
 * INTEGRACIÓN (Motion):
 *   1) Sube este archivo a  assets/geo-badges.js
 *   2) En layout/theme.liquid antes de </body> (junto a los otros scripts):
 *        <script src="{{ 'geo-badges.js' | asset_url }}" defer="defer"></script>
 *   3) El acento ya está en el azul de Motion (CONFIG.accent).
 * ========================================================================== */
(function () {
  'use strict';
  if (window.__geoBadges) return;
  window.__geoBadges = true;

  var CONFIG = {
    accent: '#0093e9',                 // azul Motion
    accent2: '#2bc4f0',                // cian Motion
    ink: '#0d3c6e',
    cacheKey: 'geo_index_v3',
    cacheTtlMs: 15 * 60 * 1000,
    // selectores del tema (Ignite estándar de Motion)
    card: '.card-wrapper, product-card',
    cardImg: '.card__media img.card__image:not(.card__image-hover), .card__media img',
    cardInfo: '.card__information',     // el contenedor con vendor + título (no el .card__content--badge sobre la foto)
    productLink: 'a[href*="/products/"]',
    gridWatch: '#product-grid, .product-grid, .motion-tab-grid, .collection, main',
  };

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  // SOLO "geometr" → matchea "Geometría (Figura)" de las conexiones y EXCLUYE
  // los manómetros cuya opción "Cofiguras sus Rangos…" (typo) contiene "figura".
  function isGeoName(name) { return String(name || '').toLowerCase().indexOf('geometr') >= 0; }

  /* ---------- CSS ---------- */
  function injectCSS() {
    if (document.getElementById('gb-css')) return;
    var a = CONFIG.accent, a2 = CONFIG.accent2;
    var css = [
      '.gb-row{display:flex;flex-wrap:wrap;gap:6px;align-items:center;padding:8px 0 10px;position:relative;z-index:3;background:inherit;font-family:inherit;}',
      '.gb-lbl{flex:0 0 100%;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;color:#8a94a3;margin-bottom:5px;min-height:13px;line-height:1.2;}',
      '.gb-lbl b{color:' + CONFIG.ink + ';font-weight:800;}',
      '.gb-sw{-webkit-appearance:none;appearance:none;cursor:pointer;flex:0 0 auto;width:36px;height:36px;padding:2px;border-radius:50%;border:1.5px solid #dfe3e8;background:#fff;overflow:hidden;transition:border-color .15s ease,transform .15s ease,box-shadow .15s ease;}',
      '.gb-sw img{width:100%;height:100%;object-fit:contain;border-radius:50%;mix-blend-mode:multiply;display:block;}',
      '.gb-sw:hover,.gb-sw.is-on{border-color:' + a + ';transform:translateY(-1px);}',
      '.gb-sw.is-on{box-shadow:0 0 0 3px ' + a + '2b;}',
      '.gb-sw:focus-visible{outline:2px solid ' + a2 + ';outline-offset:2px;}',
      // en tarjetas con swatches, la imagen la maneja el swatch: apaga el swap de 2ª imagen del tema
      '.gb-active .card__image-hover{opacity:0 !important;}',
      '@media(max-width:749px){.gb-sw{width:32px;height:32px;}.gb-row{gap:5px;padding:6px 0 8px;}.gb-lbl{font-size:9px;margin-bottom:4px;}}'
    ].join('');
    var st = document.createElement('style'); st.id = 'gb-css'; st.textContent = css;
    document.head.appendChild(st);
  }

  /* ---------- índice: handle -> [{label, thumb, big, variantId}] ---------- */
  var INDEX = null, loading = null;
  function thumb(src, w) { return src ? (src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w) : ''; }

  function buildRecord(p) {
    var gi = -1, i;
    for (i = 0; i < (p.options || []).length; i++) { if (isGeoName(p.options[i].name || p.options[i])) { gi = i; break; } }
    if (gi < 0) return null;
    var geos = [], seen = {};
    var order = (p.options[gi].values) || [];
    for (var k = 0; k < order.length; k++) {
      var val = order[k], thumbSrc = '', vid = '', imgId = '';
      for (i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        var vopt = v.options ? v.options[gi] : v['option' + (gi + 1)];   // /products.json usa option1/2/3
        if (vopt === val) {
          if (!vid) vid = v.id;
          var fi = v.featured_image || v.image;
          if (fi && fi.src && !thumbSrc) { thumbSrc = fi.src; imgId = fi.id; }
          if (thumbSrc && vid) break;
        }
      }
      if (!thumbSrc && p.images && p.images[0]) { thumbSrc = (p.images[0].src || p.images[0]); imgId = 'feat'; }
      if (imgId && seen[imgId]) continue;                 // dedupe por imagen
      seen[imgId] = 1;
      geos.push({ label: val, thumb: thumb(thumbSrc, 120), big: thumb(thumbSrc, 533), variantId: vid });
    }
    // muestra la fila también con 1 sola figura → todas las tarjetas de conexión quedan parejas
    return geos.length ? geos : null;
  }

  function fromCache() {
    try { var o = JSON.parse(sessionStorage.getItem(CONFIG.cacheKey) || 'null'); if (!o || Date.now() - o.t > CONFIG.cacheTtlMs) return null; return o.d; } catch (e) { return null; }
  }
  function toCache(d) { try { sessionStorage.setItem(CONFIG.cacheKey, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function loadIndex() {
    if (INDEX) return Promise.resolve(INDEX);
    if (loading) return loading;
    var cached = fromCache(); if (cached) { INDEX = cached; return Promise.resolve(INDEX); }
    loading = (function () {
      var map = {};
      function page(n) {
        return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (j) {
            var ps = (j && j.products) || [], i;
            for (i = 0; i < ps.length; i++) { var rec = buildRecord(ps[i]); if (rec) map[ps[i].handle] = rec; }
            if (ps.length === 250 && n < 8) return page(n + 1);
          });
      }
      return page(1).then(function () { INDEX = map; toCache(map); loading = null; return INDEX; })
        .catch(function () { loading = null; return (INDEX = INDEX || {}); });
    })();
    return loading;
  }

  /* ---------- 1) SWATCHES EN LAS TARJETAS ---------- */
  function handleOf(card) {
    var a = card.querySelector(CONFIG.productLink); if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  var GEO_LBL = (document.documentElement.lang || 'es').indexOf('en') === 0 ? 'Shape' : 'Geometría';
  function injectGrid() {
    if (!INDEX) return;
    document.querySelectorAll(CONFIG.card).forEach(function (card) {
      if (card.__gbDone) return;
      var h = handleOf(card); if (!h) return;
      var geos = INDEX[h]; if (!geos || !geos.length) { card.__gbDone = true; return; }
      var info = card.querySelector(CONFIG.cardInfo); if (!info) return;
      card.__gbDone = true;
      card.classList.add('gb-active');
      var row = document.createElement('div'); row.className = 'gb-row';
      var html = '<span class="gb-lbl">' + esc(GEO_LBL) + ': <b>' + esc(geos[0].label) + '</b></span>';
      geos.forEach(function (g, i) {
        html += '<button type="button" class="gb-sw' + (i === 0 ? ' is-on' : '') + '" data-img="' + esc(g.big) + '" data-variant="' + esc(g.variantId) + '" title="' + esc(g.label) + '" aria-label="' + esc(GEO_LBL + ': ' + g.label) + '"><img src="' + esc(g.thumb) + '" alt="" loading="lazy"></button>';
      });
      row.innerHTML = html;
      info.insertBefore(row, info.firstChild);
    });
  }

  function cardOf(el) { return el.closest ? (el.closest('.card-wrapper') || el.closest('product-card')) : null; }
  function base(u) { return (u || '').split('?')[0]; }
  function showSw(card, sw, withVar) {
    if (!card || !sw) return;
    var img = card.querySelector(CONFIG.cardImg), src = sw.getAttribute('data-img');
    if (img && src) { img.removeAttribute('srcset'); img.setAttribute('src', src); }
    var l = card.querySelector('.gb-lbl'); if (l) l.innerHTML = esc(GEO_LBL) + ': <b>' + esc(sw.getAttribute('title') || '') + '</b>';
    var vid = withVar ? sw.getAttribute('data-variant') : '';
    card.querySelectorAll(CONFIG.productLink).forEach(function (a) {
      if (!a.dataset.gbBase) a.dataset.gbBase = base(a.getAttribute('href'));
      a.setAttribute('href', vid ? (a.dataset.gbBase + '?variant=' + vid) : a.dataset.gbBase);
    });
  }
  function reset(card) {
    if (card.__gbPin) showSw(card, card.__gbPin, true);
    else { var d = card.querySelector('.gb-sw.is-on'); if (d) showSw(card, d, false); }
  }
  function wireGrid() {
    document.addEventListener('mouseover', function (e) {
      var s = e.target.closest && e.target.closest('.gb-sw'); if (!s) return; showSw(cardOf(s), s, true);
    });
    document.addEventListener('mouseout', function (e) {
      var s = e.target.closest && e.target.closest('.gb-sw'); if (!s) return;
      var to = e.relatedTarget && e.relatedTarget.closest ? e.relatedTarget.closest('.gb-sw') : null;
      if (to && cardOf(to) === cardOf(s)) return; reset(cardOf(s));
    });
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('.gb-sw'); if (!s) return;
      e.preventDefault(); var card = cardOf(s); if (!card) return;
      card.__gbPin = s;
      card.querySelectorAll('.gb-sw').forEach(function (x) { x.classList.toggle('is-on', x === s); });
      showSw(card, s, true);
    });
  }

  /* ---------- 2) PÁGINA DE PRODUCTO: auto-snap para PÍLDORAS ----------
   * Motion (Ignite) lee las variantes de los radios .checked en onVariantChange
   * (bubble) y SOLO re-renderiza cuando el combo es válido; si es inválido, sólo
   * deshabilita el botón. Por eso NO intervenimos en captura (rompería el render):
   * escuchamos el cambio DESPUÉS del tema y, si el combo quedó inválido, hacemos
   * UN click real en el tamaño compatible → el tema lo procesa limpio y reactiva
   * el botón. Delegado en document + re-consulta fresca = a prueba de re-render.
   */
  function productPage() {
    var hm = location.pathname.match(/\/products\/([^/?#]+)/); if (!hm) return;
    var vs0 = document.querySelector('variant-selects'); if (!vs0) return;
    var hasGeo = [].slice.call(vs0.querySelectorAll('fieldset legend')).some(function (l) { return isGeoName(l.textContent || ''); });
    if (!hasGeo) return;                                             // sólo conexiones con figura

    fetch('/products/' + hm[1] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var variants = prod.variants || [];
        if (variants.length < 2) return;
        var snapping = false, scheduled = false, lastLegend = null;

        function groupsNow() {
          var vs = document.querySelector('variant-selects'); if (!vs) return [];
          return [].slice.call(vs.querySelectorAll('fieldset')).map(function (fs) {
            return { legend: ((fs.querySelector('legend') || {}).textContent || '').trim(), radios: [].slice.call(fs.querySelectorAll('input[type="radio"]')) };
          }).filter(function (g) { return g.radios.length; });
        }
        function checkedVal(g) { for (var i = 0; i < g.radios.length; i++) if (g.radios[i].checked) return g.radios[i].value; return null; }
        function matches(v, vv) { for (var i = 0; i < vv.length; i++) { if (vv[i] != null && v.options[i] !== vv[i]) return false; } return true; }
        function existsAvail(vv) { return variants.some(function (v) { return v.available && matches(v, vv); }); }
        function firstFor(gIdx, val) {
          var av = null, any = null, i, v;
          for (i = 0; i < variants.length; i++) { v = variants[i]; if (v.options[gIdx] === val) { if (!any) any = v; if (v.available && !av) av = v; } }
          return av || any;
        }
        function snap() {
          scheduled = false; if (snapping) return;
          var groups = groupsNow(); if (groups.length < 2) return;
          var vv = groups.map(checkedVal); if (vv.some(function (x) { return x == null; })) return;
          if (existsAvail(vv)) return;                                // válido → no tocar la elección del cliente
          var keep = -1, i;
          for (i = 0; i < groups.length; i++) { if (lastLegend && groups[i].legend === lastLegend) { keep = i; break; } }
          if (keep < 0) for (i = 0; i < groups.length; i++) { if (isGeoName(groups[i].legend)) { keep = i; break; } }
          if (keep < 0) keep = 0;
          var target = firstFor(keep, vv[keep]); if (!target) return;
          snapping = true;
          groups.forEach(function (g, i) {
            if (i === keep) return;
            var want = target.options[i], wr = null, j;
            for (j = 0; j < g.radios.length; j++) { if (g.radios[j].value === want) { wr = g.radios[j]; break; } }
            if (wr && !wr.checked) { wr.click(); }                   // click REAL → flujo normal del tema
          });
          snapping = false;
        }
        document.addEventListener('change', function (e) {
          if (snapping) return;
          var radio = e.target && e.target.closest ? e.target.closest('input[type="radio"]') : null; if (!radio) return;
          if (!radio.closest('variant-selects')) return;
          var fs = radio.closest('fieldset');
          lastLegend = fs ? ((fs.querySelector('legend') || {}).textContent || '').trim() : null;
          if (!scheduled) { scheduled = true; setTimeout(snap, 60); }
        });
      }).catch(function () {});
  }

  /* ---------- arranque ---------- */
  function init() {
    injectCSS();
    wireGrid();
    productPage();
    loadIndex().then(function () {
      injectGrid();
      var host = document.querySelector(CONFIG.gridWatch);
      if (host && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { injectGrid(); });
        mo.observe(host, { childList: true, subtree: true });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
